import styled from 'styled-components';
import { lighten } from 'polished';

export const StyledListingItem = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-bottom: 1px solid ${props => lighten(0.3, props.theme.colors.grey)};

    &:last-of-type {
        border-bottom: 0;
    }

    .item-bind {
        font-size: 1.2rem;
        padding-left: 1.5rem;
        display: flex;
        color: ${props => props.theme.colors.primary};
        cursor: pointer;
    }
    
    .infos-name-and-description {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      font-size: 1.2rem;
    }
    
    h4 {
        width: 100%;
        text-align: left;
        font-size: 1.4rem;
        margin-bottom: 0;
    }
`;
